import { useEffect } from 'react';
import { useGameStore } from '../simulation/store';

export function useKeyboardControls(): void {
  const nudgeCamera = useGameStore((state) => state.nudgeCamera);
  const rotateCamera = useGameStore((state) => state.rotateCamera);
  const zoomCamera = useGameStore((state) => state.zoomCamera);
  const setWalkActive = useGameStore((state) => state.setWalkActive);
  const moveWalk = useGameStore((state) => state.moveWalk);
  const walk = useGameStore((state) => state.walk);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const key = event.key.toLowerCase();
      const cameraStep = event.shiftKey ? 1.5 : 0.75;
      const walkStep = event.shiftKey ? 0.38 : 0.2;

      if (key === 'escape') {
        setWalkActive(false);
        return;
      }

      if (walk.active) {
        if (key === 'w' || key === 'arrowup') {
          moveWalk({ x: Math.sin(walk.heading) * walkStep, z: Math.cos(walk.heading) * walkStep });
        }
        if (key === 's' || key === 'arrowdown') {
          moveWalk({ x: -Math.sin(walk.heading) * walkStep, z: -Math.cos(walk.heading) * walkStep });
        }
        if (key === 'a' || key === 'arrowleft') {
          moveWalk({ x: 0, z: 0 }, walk.heading + 0.14);
        }
        if (key === 'd' || key === 'arrowright') {
          moveWalk({ x: 0, z: 0 }, walk.heading - 0.14);
        }
        return;
      }

      if (key === 'w' || key === 'arrowup') {
        nudgeCamera(0, -cameraStep);
      }
      if (key === 's' || key === 'arrowdown') {
        nudgeCamera(0, cameraStep);
      }
      if (key === 'a' || key === 'arrowleft') {
        nudgeCamera(-cameraStep, 0);
      }
      if (key === 'd' || key === 'arrowright') {
        nudgeCamera(cameraStep, 0);
      }
      if (key === 'q') {
        rotateCamera(0.08);
      }
      if (key === 'e') {
        rotateCamera(-0.08);
      }
      if (key === '=' || key === '+') {
        zoomCamera(-2);
      }
      if (key === '-' || key === '_') {
        zoomCamera(2);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [moveWalk, nudgeCamera, rotateCamera, setWalkActive, walk.active, walk.heading, zoomCamera]);
}
